import * as React from "react";
import { Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

const SaveButton = (props) => {
  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "primary.dark",
        display: "flex",
        marginTop: "20px",
        height: "45px",
      }}
      startIcon={<SaveIcon />}
      onClick={props.onClick}
      {...props}
    >
      Ruaj Grafikun
    </Button>
  );
};

export default SaveButton;
